import mapi from './api';

/**
 * Anwesenheits- und Ausfallkategorien des Mandanten laden.
 * Fällt bei Fehlern auf eine leere Liste zurück — die Seite bleibt bedienbar.
 */
export async function fetchAttendanceCategories(courseId) {
  try {
    const r = await mapi.get('/attendance-categories', {
      params: courseId ? { course_id: courseId } : undefined,
    });
    return Array.isArray(r.data) ? r.data : [];
  } catch {
    return [];
  }
}

/** Ausfall im Menü: nur EA, UA und LA. Offen und Verlegen sind keine Ausfallarten. */
const AUSFALL_CODES = new Set(['ea', 'ua', 'la']);

export function cancellationCategories(categories) {
  return (categories || []).filter((c) => c.is_cancellation && AUSFALL_CODES.has(c.code));
}

/** Kategorien für die Anwesenheitserfassung (erteilt + Abwesenheiten). */
export function presenceCategories(categories) {
  return (categories || []).filter((c) => c.teacher_status || c.counts_as_taught);
}

/** Kurztext der Folgen — Fallback, wenn das Backend keinen liefert. */
export function consequenceText(category) {
  if (!category) return '';
  if (category.consequence) return category.consequence;
  const parts = [];
  if (category.counts_as_taught) parts.push('gilt als erteilt');
  if (category.is_online) parts.push('online');
  if (category.consumes_prepaid) parts.push('verbraucht Karteneinheit');
  if (category.refund_quotient > 0) parts.push(`Erstattung ${Math.round(category.refund_quotient * 100)} %`);
  if (category.requires_makeup) parts.push('nachholpflichtig');
  if (category.requires_new_date) parts.push('neuer Termin nötig');
  if (category.notify_parents) parts.push('Eltern werden informiert');
  return parts.join(' · ') || 'keine Folgen';
}
